<template>
  <div class="content" :style="navbarWithName ? 'margin-left: 150px !important; margin-right: auto !important;' : ''"> <!--note: mt,mb,ml,mr(margin) jangan diubah-->
    <v-snackbar v-model="alertSuccess" :timeout="4000" top right color='primary' >
        <v-icon x-medium class="white--text">mdi-checkbox-marked-circle</v-icon>    <span>{{ alert_err_attention }}</span>
    </v-snackbar>
    <v-snackbar v-model="alertFailed" :timeout="4000" top right color='red' >
      <v-icon x-medium class="white--text">mdi-minus-circle</v-icon>   <span>{{ alert_err_attention }}</span>
    </v-snackbar>
    <v-breadcrumbs :items="page" class="ml-2 mt-0 pt-0"></v-breadcrumbs>
    <v-card class="mx-auto ml-2 mr-2 mb-4" max-width="100%" outlined> 
      <v-dialog v-model="dialogDelete" width="330px">
        <v-card class="text-center align-center justify-center pa-6 rounded-lg" width="330px">
          <v-avatar class="color-avatar3 my-4" size="62">
            <v-icon x-large class="white--text">mdi-alert-octagon</v-icon>
          </v-avatar>
          <div class="text-center text-h6 align-center justify-center font-weight-medium">
            Confirm Deletion
          </div> 
          <v-card-text class="align-center justify-center mt-2">
            Are you sure you want to delete this item {{ text_delete }} ?
          </v-card-text>
          <v-divider class="mt-4" style=""></v-divider>
          <v-card-actions class="align-center justify-center">
            <v-btn rounded class="my-3 btn-ok" width="90px" dark @click="deleteItemConfirm">
              OK
            </v-btn>
            <v-btn rounded outlined class="my-3" width="90px" color="red" dark @click="closeDelete">
              Cancel 
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogPinnsed" max-width="400px">
        <v-card>
          <v-card-title>
            <span class="text-h6">Pinned Person</span> 
            <span class="name_action">{{ name_action_dialog }}</span>
          </v-card-title>
          <v-card-text class="overflow-card">
              <!-- Input Section 1 -->
              <div v-show=collect_news_val>

                <h4 class="my-4" style="color: #0471A5;">Account News</h4>
                <v-divider></v-divider>
                <v-container>
                  <v-row class="mt-4" v-for="(item, index) in item_account_news" :key="index">
                    <v-flex lg12>
                      <v-text-field disabled outlined dense v-model="item.account" label="Account User" readonly></v-text-field>
                      <v-text-field v-show=false v-model="item.id_account" type="hidden"></v-text-field>
                    </v-flex>
                  </v-row>
                </v-container>
              </div>
              
              <div v-show=collect_twit_val>
            
              <!-- Input Section 2 -->
                <h4  class="my-4" style="color: #0471A5;">Account Twetter</h4>
                <v-divider ></v-divider>
                <v-container >
                  <v-row class="mt-4" v-for="(item, index) in item_account_twet" :key="index">
                    <v-flex lg8>
                      <v-text-field outlined dense v-model="item.account"  @keydown="(event) => blockComma(event, index, 'twet')" @paste="handlePaste($event, index, 'twet')" label="Account User"></v-text-field>
                    
                      <div v-if="isCommaError[index]?.twet" style="margin-top: -25px; color: red;font-size: 10px; font-style: italic;">
                        Commas are not allowed! <br>
                      </div>
                    </v-flex>
                <!-- Menampilkan pesan error jika ada koma -->
               
                    <v-flex lg4>
                      <v-btn class="blue mx-2 elevation-0" @click="add_tweet" dark outlined icon color="#fff">
                        <v-icon>mdi-plus</v-icon>
                      </v-btn>
                      <v-btn class="red darken-1" @click="remove_tweet(item, index)" outlined color="#fff" icon>
                        <v-icon>mdi-delete-outline</v-icon>
                      </v-btn>
                    </v-flex>
                  </v-row>
                </v-container>
              </div>
              
              <!-- Input Section 3 -->
              
              <div v-show=collect_ig_val>

                <h4   class="my-4" style="color: #0471A5;">Account Instagram</h4>
                <v-divider  ></v-divider>
                <v-container  >
                  <v-row class="mt-4" v-for="(item, index) in item_account_ig" :key="index">
                    <v-flex lg8>
                      <v-text-field outlined dense v-model="item.account"  @keydown="(event) => blockComma(event, index, 'instagram')" @paste="handlePaste($event, index, 'instagram')" label="Account User"></v-text-field>
                      <div v-if="isCommaError[index]?.instagram" style="margin-top: -25px; color: red;font-size: 10px; font-style: italic;">
                        Commas are not allowed! <br>
                      </div>
                    </v-flex>
                    <v-flex lg4>
                      <v-btn class="blue mx-2 elevation-0" @click="add_ig" dark outlined icon color="#fff">
                        <v-icon>mdi-plus</v-icon>
                      </v-btn>
                      <v-btn class="red elevation-0" @click="remove_ig(item, index)" outlined color="#fff" icon>
                        <v-icon>mdi-delete-outline</v-icon>
                      </v-btn>
                      
                    </v-flex>
                  </v-row>
                </v-container>
              </div>
              <div v-show=collect_tiktok_val>

                <h4 class="my-4" style="color: #0471A5;">Account Tik Tok</h4>
                <v-divider></v-divider>
                <v-container>
                  <v-row class="mt-4" v-for="(item, index) in item_account_tiktok" :key="index">
                    <v-flex lg8>
                      <v-text-field outlined dense v-model="item.account"  @keydown="(event) => blockComma(event, index, 'tiktok')" @paste="handlePaste($event, index, 'tiktok')" label="Account User"></v-text-field>
                      
                      <div v-if="isCommaError[index]?.tiktok" style="margin-top: -25px; color: red;font-size: 10px; font-style: italic;">
                        Commas are not allowed! <br>
                      </div>
                    </v-flex>
                    <v-flex lg4>
                      <v-btn class="blue mx-2 elevation-0" @click="add_tiktok" dark outlined icon color="#fff">
                        <v-icon>mdi-plus</v-icon>
                      </v-btn>
                      <v-btn class="red elevation-0" @click="remove_tiktok(item, index)" outlined color="#fff" icon>
                        <v-icon>mdi-delete-outline</v-icon>
                      </v-btn>
                    </v-flex>
                  </v-row>
                </v-container>
              
              </div>
              <div v-show=collect_ytb_val>
                <h4 class="my-4" style="color: #0471A5;">Account Youtube</h4>
                <v-divider></v-divider>
                <v-container>
                  <v-row class="mt-4" v-for="(item, index) in item_account_youtube" :key="index">
                    <v-flex lg8>
                      <v-text-field outlined dense v-model="item.account" @keydown="(event) => blockComma(event, index, 'youtube')" @paste="handlePaste($event, index, 'youtube')" label="Account User"></v-text-field>
                      <div v-if="isCommaError[index]?.youtube" style="margin-top: -25px; color: red;font-size: 10px; font-style: italic;">
                        Commas are not allowed! 
                      </div>
                    </v-flex>
                    <v-flex lg4>
                      <v-btn class="blue mx-2 elevation-0" @click="add_youtube" dark outlined icon color="#fff">
                        <v-icon>mdi-plus</v-icon>
                      </v-btn>
                      <v-btn class="red elevation-0" @click="remove_youtube(item, index)" outlined color="#fff" icon>
                        <v-icon>mdi-delete-outline</v-icon>
                      </v-btn>
                    </v-flex>
                  </v-row>
                </v-container>
                
              </div>
          </v-card-text>

          
          <v-divider></v-divider>
          
          <v-card-actions class="py-3">
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" style="width: 90px;" rounded outlined dense @click="close">
              Cancel
            </v-btn>
            <v-btn color="blue darken-1" style="width: 90px;" rounded dark dense :loading="btnload" @click="postAccount">
              Save 
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>


      
      <v-card-title class="body-2 font-weight-regular blue-grey lighten-5 grey--text">
        <v-icon class="mr-2">mdi-link-variant</v-icon> {{ this.$store.state.title }}
      </v-card-title>
      <v-list-item-content>
        <v-card-text>
          <v-row class="ma-3">        
            <v-flex lg2>
            <template>
              <v-select
                  @change="valueAccount(account)"
                  :items="listAccount"
                  item-text="name"
                  item-value="valueperson"
                  label="Person"
                  dense outlined 
                  v-model="account"
                >
                  <template v-slot:selection="data">
                    <v-list-item-content>
                      <v-list-item-title >{{ data.item.name }} </v-list-item-title>
                    </v-list-item-content>
                  </template>
              </v-select>
            </template>

            </v-flex>
            <v-flex lg2>
              <v-btn class="mx-2 elevation-0"  :loading="btnload" dark  color="#0471A5" @click="addResultAccount()"><v-icon >mdi-plus</v-icon> Add Pinned</v-btn>
              <!-- <v-btn  :loading="btnload" @click="postAccount" class="elevation-0" dark color="#0471A5">Save<v-icon>mdi-save</v-icon></v-btn> -->
            </v-flex>
          </v-row>
            <v-chip v-for="(item, i) in resultAccountWithId" :key="i" class="ma-2" :class="item.COLOR" close @click:close="closeChip(item,'pin')">{{item.USER_DISPLAY_NAME}}</v-chip>       
        </v-card-text>
      </v-list-item-content>
    </v-card>
    <v-card class="mx-auto ml-2 mr-2 mb-4" max-width="100%" outlined>
      <v-card-title class="body-2 font-weight-regular blue-grey lighten-5 grey--text">
        <v-icon class="mr-2">mdi-air-filter</v-icon> List Detail {{ this.$store.state.title }}

        <v-flex class="table-user ml-auto rounded-lg" lg3>
          <v-text-field class="pt-3 mr-2" v-model="search" append-icon="mdi-magnify" label="Search"></v-text-field>
        </v-flex>
      </v-card-title>

      <v-row class="fill-height" no-gutters>
        

        <v-col cols="12">
          <v-data-table
            :headers="dynamicHeaders"
            :items="datatable"
            :search="search"
            class="table-user ml-6 mr-6 mt-4 rounded-lg"
            :loading="tableLoading"
            loading-text="Loading data..."
            :items-per-page="5"
          >
            <template v-slot:[`item.actions`]="{ item }">
              <v-icon small class="mr-2"  @click="updateAccount(item)"  v-if="session_user_id !== item.USER_ID">
                mdi-pencil
              </v-icon>
              <v-icon small @click="closeChip(item,'table')"  v-if="session_user_id !== item.USER_ID">
                mdi-delete
              </v-icon>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-card>


        <Notification  ref="alert"></Notification>
  </div>
</template>
<script>
import axios from "axios";
// import {jwtDecode} from "jwt-decode";
import { decryptionData } from '@/components/utils/utils.js';
import Notification from  '@/components/Notification';
import { mapGetters } from 'vuex';
  export default {
    components: {
      Notification: Notification
    },
    data () {
      return {
      tableLoading : false,
        type_delete:"",
        action_btn:"",
        isCommaError: [], // Status error koma
        datatable: [],
        dialogDelete: false,
        search:'',
        collect_news_val: true,
        collect_twit_val: true,
        collect_ig_val: true,
        collect_tiktok_val: true,
        collect_ytb_val: true,
        dialogPinnsed:false,
        pinned_id: '',
        person_id: '',
        session_user_id: '',
        name_action_dialog: '',
        item_account_news: [
          {account : '',id_account : '',collection: ''}
        ],
        
        item_account_twet: [
          {account : '',id_account : '',collection: ''}
        ],
        
        item_account_ig: [
          {account : '',id_account : '',collection: ''}
        ],
        
        item_account_tiktok: [
          {account : '',id_account : '',collection: ''}
        ],
        
        item_account_youtube: [
          {account : '',id_account : '',collection: ''}
        ],
        btnload:false,
        alertSuccess:'',
        alertFailed:'',
        alert_err_attention: "",
        text_delete:"",
        isAdd: false,
        uniqueId: "",
        account: "",
        addvalPinned: "",
        valueAddAccount:[],
        listAccount: [
          {
            name: '', 
            valueperson: '',
            subtitle:''
          }
        ],
        
        resultAccount: [],
        resultAccountWithId: [],
        resultrealAccount:[],
        indexDelete: [],
        chip1: true,
        chip2: true,
        chip3: true,
        chip4: true,
      }
    },
    computed: {

      page() {
        return this.$store.state.breadcrumbs
      },
      ...mapGetters(['navbarWithName']), // Accessing navbarWithName from Vuex
       // Dynamically determine which headers to show
      dynamicHeaders() {
        // Define the base headers
        const baseHeaders = [
          { text: 'User Display Name', value: 'USER_DISPLAY_NAME' },
          { text: 'News', value: 'NEWS' },
          { text: 'Twitter', value: 'TWITTER' },
          { text: 'Instagram', value: 'INSTAGRAM' },
          { text: 'Tik Tok', value: 'TIKTOK' },
          { text: 'Youtube', value: 'YOUTUBE' },
          { text: 'USERS CREATED', value: 'USER_INSERT' },
          { text: 'Actions', value: 'actions', sortable: false }
        ];

        // Filter out the Instagram and YouTube columns if they are not active
        let filteredHeaders = baseHeaders;

        if (this.collect_news_val  == false) {
          filteredHeaders = filteredHeaders.filter(header => header.value !== 'NEWS');
        }
        
        if (this.collect_twit_val  == false) {
          filteredHeaders = filteredHeaders.filter(header => header.value !== 'TWITTER');
        }
        if (this.collect_ig_val == false) {
          filteredHeaders = filteredHeaders.filter(header => header.value !== 'INSTAGRAM');
        }
        if (this.collect_tiktok_val == false) {
          filteredHeaders = filteredHeaders.filter(header => header.value !== 'TIKTOK');
        }

        if (this.collect_ytb_val  == false) {
          filteredHeaders = filteredHeaders.filter(header => header.value !== 'YOUTUBE');
        }
        return filteredHeaders;
      }
    },
    mounted(){
      this.getResultAccount()
      // this.initialize()

    },
    
    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },
    methods:{   
      blockComma(event, index,source) {
        // 188 adalah kode untuk koma (',')
        if (event.keyCode === 188) {
          event.preventDefault();  // Mencegah input koma
          // this.$set(this.isCommaError, index, true);  // Set error untuk index ini
          this.$set(this.isCommaError, index, { ...this.isCommaError[index], [source]: true });
          setTimeout(() => {
            this.$set(this.isCommaError, index, { ...this.isCommaError[index], [source]: false });
          }, 3000);
        }else{
          // this.isCommaError[index] = false;
          // this.$set(this.isCommaError, index, false);  // Set error untuk index ini
          this.$set(this.isCommaError, index, { ...this.isCommaError[index], [source]: false });

        }
      },

      // Fungsi untuk menangani event paste
      handlePaste(event, index,source) {
        const pastedText = event.clipboardData.getData('text');  // Ambil teks yang dipaste
        if (pastedText.includes(',')) {
          event.preventDefault();  // Batalkan paste jika ada koma
          this.$set(this.isCommaError, index, { ...this.isCommaError[index], [source]: true });
          setTimeout(() => {
            this.$set(this.isCommaError, index, { ...this.isCommaError[index], [source]: false });
          }, 3000);
        }
      },
      async getResultAccount(){      
          axios.get("bot-target",
            { headers:{'auth-token':localStorage.getItem('token_app')}},
            {dataType: 'json'}
            ).then((response) => {
              let res = decryptionData(response.data.token);
              let data_encript = res.data;
              this.datatable = res.data_table;
              this.session_user_id = res.user_id
              
              // console.log(this.datatable);


            this.collect_news_val = res.collection_news;
            this.collect_twit_val = res.collection_twitter;
            this.collect_ig_val = res.collection_instagram;
            this.collect_tiktok_val = res.collection_tiktok;
            this.collect_ytb_val = res.collection_ytb;


              // console.log(res.collection_news)
              let resultpin = '';
              let colorpin = '';
              this.resultAccountWithId =[]
              if(data_encript.pinned.length > 0){
                for (let i = 0; i <  data_encript.pinned.length; i++) {  
                  if(data_encript.pinned[i].USER_TYPE === 0){
                    colorpin = '';
                  }
                  if(data_encript.pinned[i].USER_TYPE === 1){
                    colorpin = 'primary';
                  }
                  if(data_encript.pinned[i].USER_TYPE === 2){
                    colorpin = 'error';
                  }
                  resultpin = {
                      SEQ_ID : data_encript.pinned[i].SEQ_ID,
                      PERSON_ID  : data_encript.pinned[i].PERSON_ID,
                      GROUP_ID  : data_encript.pinned[i].GROUP_ID,
                      USER_ID  : data_encript.pinned[i].USER_ID,
                      USER_DISPLAY_NAME  : data_encript.pinned[i].USER_DISPLAY_NAME,
                      
                      COLOR  : colorpin
                    };
                    
                    this.resultAccountWithId.push(resultpin);
                }
              }

              let result = '';
              // let resultpromp = '';
              let type = '';
              let arr_data = [];
              if(data_encript.peson_select.length > 0){
                for (let i = 0; i <  data_encript.peson_select.length; i++) {  
                    if(i == 1){
                      this.peson_select_id = (data_encript.peson_select[i].SEQ_ID);
                    }
                    
                    if(data_encript.peson_select[i].USER_TYPE == 0){
                      type = 'News';
                    }else if(data_encript.peson_select[i].USER_TYPE == 1){
                      type = 'Twetter';
                    }else{
                      type = 'Youtube';
                    }
                    result = {
                      valueperson : data_encript.peson_select[i].SEQ_ID,
                      name  : data_encript.peson_select[i].USER_DISPLAY_NAME,
                      subtitle  : type
                    };
                    
                    // resultpromp = {
                    //   title : data_encript.peson_select[i].USER_ID,
                    //   subtitle  : type
                    // };
                    arr_data.push(result);
                    // this.listAccountpromp.push(resultpromp);
                    
                }
                this.listAccount= arr_data;
              }
              this.resultAccount = data_encript.peson_select    
              this.isAdd = false
            })
            .catch((e) => {
                switch (e.response.status) {
                    case 404:
                          this.$refs.alert.error_login(404);
                        break;
                    case 403:
                          this.$refs.alert.error_login(403);
                        break;
                    default:
                        console.log('some other error');  // end up here all the time
                        break;
                }
            console.log(e)
          });  
      },  
      addResultAccount(){
        this.pinned_id = ""
        
        if(this.account == ''){ 
          this.alertFailed = true;
          this.alert_err_attention =  "Person has been add" ;
        }else if(this.resultAccount.includes(this.account)){
          this.alertFailed = true;
          this.alert_err_attention =  "Account has been add" ;
        }else {
          this.resultAccount.forEach((element) => {
            // var color ="";
            if(element["SEQ_ID"] == this.account){

              this.resultAccountWithId.forEach((elm) => {
                if(elm["PERSON_ID"] == this.account){
                this.addvalPinned = -1
                }else{

                  this.addvalPinned = 1
                }
              });
              if(this.addvalPinned == -1){

                this.alertFailed = true;
                  this.alert_err_attention =  "Account has been exist" ;
              }else{
                  axios({
                    method: "put",
                    url: "get-bot-target",
                    data: {
                      id: element['SEQ_ID']
                    },
                    headers:{'auth-token':localStorage.getItem('token_app')},
                    dataType: 'json'
                  }).then((response) => {
                      let result = decryptionData(response.data.token);
                      
                      const alias = result.alias_person;
                      this.item_account_news =[];
                      
                      if(alias.length > 0){
                        for (let i = 0; i <  alias.length; i++) { 
                          this.item_account_news.push({account: alias[i].NER_ALIAS ,id_account: alias[i].SEQ_ID ,collection: this.collect_news_val});
                        }
                      }else{
                        this.item_account_news =[];
                        this.item_account_news.push({ account : '',id_account : '',collection: this.collect_news_val })
                      }
            

                        // ======end history === 
                      const history = result.data_history;
                      this.action_btn = 'add';

                      if( history != undefined){
                        this.pinned_id = history.SEQ_ID

                        let twittArray = history.TWITTER.split(',').map(item => item.trim());  // Menambahkan trim untuk menghapus spasi ekstra
                        this.item_account_twet = [];
                        twittArray.forEach(data => {
                            this.item_account_twet.push({
                                account: data,
                                id_account: '',
                                collection: this.collect_twit_val
                            });
                        });
              
                        let igArray = history.INSTAGRAM.split(',').map(item => item.trim());  // Menambahkan trim untuk menghapus spasi ekstra
                        this.item_account_ig = [];
                        igArray.forEach(data => {
                            this.item_account_ig.push({
                                account: data,
                                id_account: '',
                                collection: this.collect_ig_val
                            });
                        });
                        
                        let tiktokArray = history.TIKTOK.split(',').map(item => item.trim());  // Menambahkan trim untuk menghapus spasi ekstra
                        this.item_account_tiktok = [];
                        tiktokArray.forEach(data => {
                            this.item_account_tiktok.push({
                                account: data,
                                id_account: '',
                                collection: this.collect_tiktok_val
                            });
                        });
                        
            
                        let ytbArray = history.YOUTUBE.split(',').map(item => item.trim());  // Menambahkan trim untuk menghapus spasi ekstra
                        this.item_account_youtube = [];
                        ytbArray.forEach(data => {
                            this.item_account_youtube.push({
                                account: data,
                                id_account: '',
                                collection: this.collect_ytb_val
                            });
                        });
                        // ======end history === 
                      }else{
                        this.pinned_id = ""

                        this.item_account_twet =[];
                        this.item_account_twet.push({ account : '',id_account : '',collection: this.collect_twit_val })
            
                        this.item_account_ig =[];
                        this.item_account_ig.push({ account : '',id_account : '',collection: this.collect_ig_val })

                        
                        this.item_account_tiktok =[];
                        this.item_account_tiktok.push({ account : '',id_account : '',collection: this.collect_tiktok_val })
                        
                        this.item_account_youtube =[];
                        this.item_account_youtube.push({ account : '',id_account : '',collection: this.collect_ytb_val })
                    
                      }
                      
                      this.person_id = element['SEQ_ID']
                      this.name_action_dialog = element['USER_DISPLAY_NAME']
                      
                      this.dialogPinnsed = true

                  })
                  .catch((e) => {
                      switch (e.response.status) {
                          case 404:
                                this.$refs.alert.error_login(404);
                              break;
                          case 403:
                                this.$refs.alert.error_login(403);
                              break;
                          default:
                              console.log('some other error');  // end up here all the time
                              break;
                      }
                  console.log(e)
                }); 

              }

            }
          })



        }
      },
      valueAccount(account){  
        const uuidv4 = require('uuid/v4');     
        this.uniqueId = uuidv4()
        console.log(account);
      },
      closeChip(item,type){ 

        this.type_delete = type
        this.pinned_id = item.SEQ_ID
        this.dialogDelete = true
        this.text_delete = "list detail pinned and Bot Target"

        if(type == 'pin'){
          this.text_delete = "Bot Target"
        }
      },
      
      deleteItemConfirm(){ 
        this.indexDelete.push(this.pinned_id)
        this.isAdd = true  
          let url = "/bot-target-history/delete"
          if(this.type_delete == 'pin'){
              url = "/bot-target/delete"
          }
          axios({
            method: "delete",
            url: url,
            data: {
              id_pinned: this.pinned_id
            },
            headers:{'auth-token':localStorage.getItem('token_app')},
            dataType: 'json'
          })
          .then((response) => {
            // handle success
              var status = response.data.status
              var messages = response.data.msg
              if(status == 200){
                this.getResultAccount()
                this.alertSuccess = true;
                this.alert_err_attention =  messages;

              }else{
                  this.alertFailed = true;
                  this.alert_err_attention =  messages;
              } 
              this.dialogDelete = false

          })
          .catch(function (error) {
            this.dialogDelete = false

            this.alertFailed = true;
            this.alert_err_attention =  'Delete Failed '+error;
          })
          this.resultAccountWithId = removeObjectWithId(this.resultAccountWithId, this.pinned_id);
    
        function removeObjectWithId(arr, id) {
        return arr.filter((obj) => obj.SEQ_ID !== id);
        }
      },
      
      
      closeDelete () {
        this.dialogDelete = false
        this.pinned_id = ""
        this.action_btn = ""
      },
      async postAccount(){
        // person_id,item_account_news,item_account_twet,item_account_ig,item_account_tiktok,item_account_youtube
// console.log( this.isAdd)
        this.btnload = true
        if(this.person_id != "" || this.isAdd == true){
          axios.post("/bot-target/action", 
          {
              action : this.action_btn,
              pinned_id :this.pinned_id,
              person_id :this.person_id,
              account_news :this.item_account_news,
              account_twet :this.item_account_twet,
              account_ig :this.item_account_ig,
              account_tiktok :this.item_account_tiktok,
              account_youtube :this.item_account_youtube,
            },
            { headers:{'auth-token':localStorage.getItem('token_app')}},
            {dataType: 'json'}
            )
          .then((response) => {
              var status = response.data.status
              var messages = response.data.msg
              if(status == 200){
                this.getResultAccount();
                this.alertSuccess = true;
                this.alert_err_attention =  messages;
                this.btnload = false
                this.close();
              }else{
                  this.alertFailed = true;
                  this.alert_err_attention =  messages;
                  this.btnload = false
              } 
            })
          .catch((e) => {
                switch (e.response.status) {
                    case 404:
                          this.$refs.alert.error_login(404);
                        break;
                    case 403:
                          this.$refs.alert.error_login(403);
                        break;
                    case 400:
                          this.alertFailed = true;
                          this.alert_err_attention =  e.response.data.msg;
                          this.btnload = false
                        break;
                    default:
                        console.log('some other error');  // end up here all the time
                        break;
                    }
            this.errors=e.response.data.msg;
          });   
        }else{
            this.alertFailed = true;
            this.alert_err_attention =  "Account has not been added" ;
            this.btnload = false
        }                
      },
      
      updateAccount (item) {
        this.action_btn = 'update';
        console.log(item)
        axios({
          method: "put",
          url: "analyzer_person_Id",
          data: {
            id: item.PERSON_ID
          },
          headers:{'auth-token':localStorage.getItem('token_app')},
          dataType: 'json'
        })
        .then((response) => {
            console.log(response.data);
            let result = decryptionData(response.data.token);
            
            const alias = result.alias_person;
            this.item_account_news =[];
            
            if(alias.length > 0){
              for (let i = 0; i <  alias.length; i++) { 
                this.item_account_news.push({account: alias[i].NER_ALIAS ,id_account: alias[i].SEQ_ID ,collection: this.collect_news_val});
              }
            }else{
              this.item_account_news =[];
              this.item_account_news.push({ account : '',id_account : '',collection: this.collect_news_val })
            }

            let twittArray = item.TWITTER.split(',').map(item => item.trim());  // Menambahkan trim untuk menghapus spasi ekstra
            this.item_account_twet = [];
            twittArray.forEach(data => {
                this.item_account_twet.push({
                    account: data,
                    id_account: '',
                    collection: this.collect_twit_val
                });
            });
  
            let igArray = item.INSTAGRAM.split(',').map(item => item.trim());  // Menambahkan trim untuk menghapus spasi ekstra
            this.item_account_ig = [];
            igArray.forEach(data => {
                this.item_account_ig.push({
                    account: data,
                    id_account: '',
                    collection: this.collect_ig_val
                });
            });
            
            let tiktokArray = item.TIKTOK.split(',').map(item => item.trim());  // Menambahkan trim untuk menghapus spasi ekstra
            this.item_account_tiktok = [];
            tiktokArray.forEach(data => {
                this.item_account_tiktok.push({
                    account: data,
                    id_account: '',
                    collection: this.collect_tiktok_val
                });
            });
            
            let ytbArray = item.YOUTUBE.split(',').map(item => item.trim());  // Menambahkan trim untuk menghapus spasi ekstra
            this.item_account_youtube = [];
            ytbArray.forEach(data => {
                this.item_account_youtube.push({
                    account: data,
                    id_account: '',
                    collection: this.collect_ytb_val
                });
            });
  

            this.pinned_id = item.PINNED_PERSON_ID
            this.person_id = item.PERSON_ID
            this.name_action_dialog = item.USER_DISPLAY_NAME
            this.dialogPinnsed = true
            
            
        })
        .catch(function (error) {
          // handle error
          console.log(error);
        })
      },
      add_news() {
        this.item_account_news.push({ account: '' ,id_account: '', collection: '' })
      },
      
      remove_news(item, index) {
        if(index > 0){
          this.item_account_news.splice(index, 1)
        }else{
          this.alertFailed = true;
          this.alert_err_attention =  "The First Line cannot be deleted" ;
        }
      },
      add_tweet() {
        this.item_account_twet.push({ account: '' ,id_account: '', collection: this.collect_twit_val })
      },
        
      
      remove_tweet(item, index) {
        if(index > 0){
          this.item_account_twet.splice(index, 1)
        }else{
          this.alertFailed = true;
          this.alert_err_attention =  "The First Line cannot be deleted" ;
        }
      },
      
      add_ig() {
        this.item_account_ig.push({ account: '' ,id_account: '', collection: this.collect_ig_val })
      },
        
      
      remove_ig(item, index) {
        if(index > 0){
          this.item_account_ig.splice(index, 1)
        }else{
          this.alertFailed = true;
          this.alert_err_attention =  "The First Line cannot be deleted" ;
        }
      },
      
      add_tiktok() {
        this.item_account_tiktok.push({ account: '' ,id_account: '', collection: this.collect_tiktok_val })
      },
        
      remove_tiktok(item, index) {
        if(index > 0){
          this.item_account_tiktok.splice(index, 1)
        }else{
          this.alertFailed = true;
          this.alert_err_attention =  "The First Line cannot be deleted" ;
        }
      },
      
      add_youtube() {
        
        this.item_account_youtube.push({ account: '' ,id_account: '', collection: this.collect_ytb_val })
      },
        
      remove_youtube(item, index) {
        if(index > 0){
          this.item_account_youtube.splice(index, 1)
        }else{
          this.alertFailed = true;
          this.alert_err_attention =  "The First Line cannot be deleted" ;
        }
      },
      close () {
        this.person_id =""
        this.action_btn = ""
        this.pinned_id = ""

        this.item_account_news =[];
        this.item_account_news.push({ account : '',id_account : '',collection: this.collect_news_val })

        this.item_account_twet =[];
        this.item_account_twet.push({ account : '',id_account : '',collection: this.collect_twit_val })

        this.item_account_ig =[];
        this.item_account_ig.push({ account : '',id_account : '',collection: this.collect_ig_val })

        this.item_account_tiktok =[];
        this.item_account_tiktok.push({ account : '',id_account : '',collection: this.collect_tiktok_val })
        
        this.item_account_youtube =[];
        this.item_account_youtube.push({ account : '',id_account : '',collection: this.collect_youtube_val })

        this.isAdd = false  
        
        this.dialogPinnsed = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
    }
  }
</script>
<style scoped>
 
.name_action {
    font-size: 12px; /* Ukuran font lebih kecil */
    font-weight: normal; /* Tidak bold */
    font-style: italic; /* Memiringkan teks */
    margin-left: 3px; 
    margin-top:6px;
}
.btn-ok{
  background-image: linear-gradient(to bottom, #ff8b8b, #ff8284, #ff787d, #ff6e76, #ff646f, #ff5c6a, #ff5464, #ff4b5f, #ff4359, #ff3b54, #ff314e, #ff2648);
}
.v-avatar.color-avatar3
{
  box-shadow: 0 5px 15px rgba(255, 0, 0, 0.4);
  background-image: linear-gradient(to bottom, #ff8b8b, #ff8284, #ff787d, #ff6e76, #ff646f, #ff5c6a, #ff5464, #ff4b5f, #ff4359, #ff3b54, #ff314e, #ff2648);
}
</style>